import React from 'react';
import './modal-copia.component.scss';
import { Button, Dialog, DialogTitle, TextField } from '@mui/material';
import { SnackService } from '../../services/snack.service';

export interface ModalCopiaComponentProps {
  open: boolean;
  criarCopia: (value: string) => void;
  onClose: () => void;
}

function ModalCopiaComponent(props: ModalCopiaComponentProps) {

  const { onClose, criarCopia, open } = props;
  const [nomeCopiaInput, setNomeCopiaInput] = React.useState('');

  const CriaCopia = () => {
    if(nomeCopiaInput){
      criarCopia(nomeCopiaInput);
      setNomeCopiaInput('');
    }else{
      SnackService.sendMSG('Informe o nome da cópia!');
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open} className='modal-copia'>
      <DialogTitle>Criar cópia desta versão de site</DialogTitle>
      <div className="campo w100">
        <TextField value={nomeCopiaInput} onChange={(event) => setNomeCopiaInput(event.target.value)} label="Nome da cópia" />
      </div>
      <Button onClick={CriaCopia}>Criar cópia</Button>
    </Dialog>
  );
}

export default ModalCopiaComponent;
